<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Duplicar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ aulaDuplicada.tipo_de_aula }}
                    </p>
                  </v-col>

                  <!-- <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Data</e-label>
                      <e-date-picker v-model="dataAulaDuplicada" :error-messages="errors" />
                    </ValidationProvider>
                  </v-col> -->

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Selecione uma data</e-label>
                        <v-text-field
                          dense
                          solo
                          v-model="data"
                          label="data"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="dataAulaDuplicada"
                        :allowed-dates="datasPermitidas"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="aulaDuplicada.tipo_de_aula !== 'Aula Remota'"
                    cols="6"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horarios"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        @change="() => pesquisaAulas()"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <!-- Conteudo da aula -->
                <div>
                  <e-conteudo-aula-infantil v-if="aulaInfantil" :aula="aulaDuplicada" />
                  <e-conteudo-aula-regular v-else :aula="aulaDuplicada" />
                </div>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false)"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="submittingForm || faltaPreencher || conflitouAula"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
import EConteudoAulaInfantil from "./EConteudoAulaInfantil.vue";
import EConteudoAulaRegular from "./EConteudoAulaRegular.vue";

export default {
  components: { EConteudoAulaInfantil, EConteudoAulaRegular },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    aulaOriginal: {
      type: Object,
      require: true,
    },
    horariosOriginais: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    datasPermitidas: {
      type: Function,
    },
  },
  data() {
    return {
      data: null,
      date: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      horarios: [],
      conflitouAula: false,
    };
  },
  computed: {
    faltaPreencher() {
      return !this.data || !this.horarioSelecionado || !this.horarioSelecionado.id;
    },
    aulaInfantil() {
      return this.aulaDuplicada.e_aula_infantil === 1;
    },
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) return;
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
      this.filtrarHorariosPorDiaDaSemana(new Date(value).getDay());
      this.pesquisaAulas();
    },
  },
  methods: {
    enableSubmit() {
      this.confirmDialog = !this.confirmDialog;
      this.aulaDuplicada.data = this.dataAulaDuplicada;
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.aulaOriginal.disciplina_id;
        this.aulaDuplicada.turma_id = this.aulaOriginal.turma_id;
        this.aulaDuplicada.instrutor_id = this.aulaOriginal.instrutor_id;
        await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        this.$toast.success("Aula duplicada com sucesso!");
        this.resetarFormulario();
        // this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      if (!this.aulaOriginal.gestao.relacoesDiasHorarios) return;
      this.horarios = this.horariosOriginais;
      this.horarios = this.aulaOriginal.gestao.relacoesDiasHorarios
        .filter((relacao) => relacao.dia.id === diaDaSemana)
        .map((relacao) => relacao.horario);
    },
    async pesquisaAulas() {
      if (!this.dataAulaDuplicada || !this.horarioSelecionado.id || !this.aulaDuplicada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitos(
        this.dataAulaDuplicada,
        this.horarioSelecionado.id,
        this.aulaDuplicada.turma.id,
        null // sem aula_id
      );
      if (response.data?.length === 0) {
        this.conflitouAula = false;
        this.$emit("conflitouAula", { status: false, conflitos: [] });
      } else {
        this.conflitouAula = true;
        this.$emit("conflitouAula", { status: true, conflitos: response.data });
      }
    },
    async resetarFormulario() {
      this.aulaDuplicada = { ...this.aulaOriginal };
      this.horarioSelecionado = { descricao: "Escolha um horario" };
      this.dataAulaDuplicada = null;
      this.data = null;
      this.conflitou = false;
    },
  },
};
</script>
